<template>
  <div>
    <px-modal 
        v-show="verModal" 
        @verModal="verModal = $event" 
        idModal="changePassw" 
        textHeader="Cambiar contraseña"
        modalWidth="500px"
    >
      <ChangePassword @verModal="verModal = $event" />
    </px-modal>
  <header class="bg-surface-variant">
    <vs-navbar class="shadow-sm vs-navbar" square center-collapsed fixed>
      <template #left>
        <div class="text-right">
          <img class="SiaheLogoHeader d-block" src="@/assets/img/SIAHE.svg" width="100px" alt="" />          

          <!-- <img src="@/assets/img/LOGO.svg" class="mt-4 mb-0"  width="100" />
          <img src="@/assets/img/letras.svg" class="mt-3 mb-2 d-block" width="150" />   -->

          <p class="version">{{ $Version }}</p>
        </div>
        <!-- <vs-button class="btn-transparent" @click="handleCerrarSesion()">
          <px-icon img="salir" color="background" class="me-2" />
          <span class="text-surface">Cerrar Sessión</span>
        </vs-button> -->
        </template>

        <template>
          <div v-if="usuario"> 
            <h6 class="text-surface mb-0">{{usuario.desc_TipoDeUsuario}}</h6>
          </div> 
        </template>

        <template #right>
          <vs-button
          class="btn-transparent dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
        <img src="@/assets/img/user.svg" width="28px" alt="">  
        <!-- <div class="text-right">
          <img class="SiaheLogoHeader d-block" src="@/assets/img/SIAHE.svg" width="100px" alt="" />
          <p class="version">{{ $ProyectosVersion }}</p>
        </div> -->
        </vs-button>
        <ul class="dropdown-menu py-0">
          <li class="px-3 padding-y-3 bg-surface text-primary-variant border-bottom">
            {{ usuario.nombre }}
          </li>
          <li class="border-bottom">
            <a class="dropdown-item py-3 px-4" href="#" @click="verModal=true"
              ><i class="fa-solid fa-key text-muted me-2"></i>
              Cambiar contraseña</a
            >
          </li>
          <li>
            <a class="dropdown-item py-3 px-4" href="#" @click="handleCerrarSesion()"
              ><i class="fa-solid fa-arrow-right-from-bracket text-muted me-2"></i>
              Cerrar sesión</a
            >
          </li>
        </ul>
          <!-- <div class="text-right">
            <img class="SiaheLogoHeader d-block" src="@/assets/img/SIAHE.svg" width="100px" alt="" />
            <p class="version">{{ $Version }}</p>
          </div> -->
        </template>
    </vs-navbar>
  </header>
</div>
</template>

<script>
import ChangePassword from '@/views/ChangePassword.vue'
import mapHelper from "@/store/modules/common/map-helper";
import PxModal from '@/components/PxModal.vue'
export default {
  components: { PxModal, ChangePassword },
  data: function () {
    return {
      active: "",
      depSelec: [],
      verModal: false
    };
  },
  created(){
    const selectedDependencia = localStorage.getItem('SIGHA-Dep-A-26');
    if(selectedDependencia){
      this.depSelec = JSON.parse(selectedDependencia);
    }else{
      this.depSelec = this.dependencias[0];
    }
  },
  beforeDestroy(){
    localStorage.removeItem('SIGHA-Dep-A-26');
  },
  mounted() {},
  methods: {
    async handleCerrarSesion() {
      localStorage.removeItem('SIGHA-Dep-A-26');
    localStorage.clear();
      await this.$store.dispatch(
        mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.logOut
      );
      this.$router.push({ name: "Login" });
    },
  },
  computed: {
    usuario() {
      return this.$store.getters[mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.getUsuario] || {};
    },
    dependencias() {
      return (this.$store.getters[mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.getIntegrado]).map(function (listadoDependencia) {
          let depElemnt = {};
          depElemnt.id = listadoDependencia.idDependencia;
          depElemnt.text = listadoDependencia.descripcion;
          return depElemnt;
        });
    },
  },
  watch: {
     depSelec(){
      localStorage.setItem('SIGHA-Dep-A-26', JSON.stringify(this.depSelec));      
      this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH + 
      mapHelper.mapfn.cambioIdDependencia, this.depSelec)
    },
   /* usuario:{ 
      handler(){
        this.depSelec = this.dependencias[0]
        }
      },
      deep:true*/
  },
};
</script>

<style scoped>

.dropdown-menu{
  border-radius: 7px;
  font-size: .9rem;
}
.dropdown-menu>.text-primary-variant { font-weight: 500; }
.padding-y-3 {
  padding-top: .8rem !important;
  padding-bottom: 0.7rem !important;
}
</style>